
<div class="layout-topbar">
    <div class="topbar-left">
        <a #menubutton tabindex="0" class="menu-button p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-chevron-left"></i>
        </a>
        <img class="horizontal-logo" [routerLink]="['/']" [src]="'assets/layout/images/logo-'+ logo + '.svg'"
            alt="diamond-layout" />
        <span class="topbar-separator"></span>
        <app-breadcrumb></app-breadcrumb>
        <a [routerLink]="['/accueil']" class="mobile-logo">
            <img class="mobile-logo" [src]="'assets/layout/images/logo-'+ logo + '.svg'" alt="diamond-layout"/>
        </a>
    </div>

    <app-sidebar></app-sidebar>
    <div class="layout-mask modal-in"></div>

    <div class="topbar-right">
        <ul class="topbar-menu">

            <li class="static sm:relative" *ngIf="showLangs">
                <p-dropdown [(ngModel)]="selectedLang" [options]="langs" optionLabel="label" optionValue="value" (onChange)="onChangeLang()"></p-dropdown>
            </li>

            <li class="static sm:relative">  <!-- Affichage bloc notification -->
                <a tabindex="0" pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                    <i id="notification" class="pi pi-bell"></i>
                  <div *ngIf="countNotification !== 0">
                    <span class="topbar-badge" style="height: 1.2rem; width: 1.2rem;"
                        *ngIf="countNotification < 100 ; else count">{{countNotification}}</span>
                    <ng-template #count>
                        <span class="topbar-badge" style="height: 1.35rem; width: 1.35rem;" *ngIf="countNotification > 100">+99</span>
                    </ng-template>
                  </div>
                </a>

                <ul
                    class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-19rem mt-2 left-0 top-auto">
                    <li *ngFor="let element of listNotification">
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            style="color: inherit; text-decoration: none;" *ngIf="element.source=='DEMANDES'"
                            [routerLink]="['/suivi-des-demandes']">
                            <i class="pi pi-file-o mr-4"></i>

                            <span class="flex flex-column">
                                <span class="font-semibold" id="demande">{{'topBar.notification.Nouvelles_demandes' | translate}}</span>
                                <span *ngIf="countDemandNotification ; else demandesBlock"
                                    class="text-color-secondary">{{'topBar.notification.vous_avez' | translate}}
                                    <strong>{{countDemandNotification}}</strong> {{'topBar.notification.nouvelle_demande'
                                    | translate}}</span>
                                <ng-template #demandesBlock>
                                    <span class="text-color-secondary">{{'topBar.notification.vous_avez' | translate}}
                                        <strong>{{countDemandNotification}}</strong>
                                        {{'topBar.notification.nouvelles_demandes' | translate}}</span>
                                </ng-template>
                            </span>
                        </a>

                        <hr *ngIf="element.source=='DEMANDES'"> <!-- Ligne de séparation -->
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            style="color: inherit; text-decoration: none;" *ngIf="element.source=='GED'"
                            [routerLink]="['/mes-courriers']">
                            <i class="pi pi-envelope mr-3"></i>


                            <span class="flex flex-column">
                                <span class="font-semibold" id="courries">{{'topBar.notification.nouveaux_courriers' | translate}}</span>
                                <span *ngIf="countGedNotification==1 ; else courriersBlock"
                                    class="text-color-secondary">{{'topBar.notification.vous_avez' | translate}}
                                    <strong>{{countGedNotification}}</strong> {{'topBar.notification.nouveau_document'| translate}}</span>
                                <ng-template #courriersBlock>
                                    <span class="text-color-secondary">{{'topBar.notification.vous_avez' | translate}}
                                        <strong>{{countGedNotification}}</strong>{{'topBar.notification.nouveaux_documents' | translate}}</span>
                                </ng-template>
                            </span>
                        </a>
                        <hr *ngIf="element.source=='MONTANT' && element.notification>0 && paiementEnLigne.show"> <!-- Ligne de séparation -->
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            style="color: inherit; text-decoration: none;" *ngIf="element.source=='MONTANT' && element.notification>0 && paiementEnLigne.show"
                            [routerLink]="['/cotisations']">
                            <i class="pi pi-euro mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold" id="paiement" >{{'topBar.notification.montant_a_payer' |
                                    translate}}</span>
                                <span class="text-color-secondary">{{'topBar.notification.vous_avez' | translate}}
                                    <strong>{{countAmountNotification}} </strong> € {{'topBar.notification.non_payes' |
                                    translate}}</span>

                            </span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="profile-item static sm:relative">


                <a tabindex="0" pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                    <p-avatar [label]="avatarInitials" styleClass="p-mr-3" *ngIf=" (access?.civilite?.toUpperCase() === 'M') || (access?.civilite?.toUpperCase() === 'MONSIEUR')" [ngStyle]="{'color': '#1f2d89'}" size="large" ></p-avatar>
                    <p-avatar [label]="avatarInitials" styleClass="p-mr-3" *ngIf="access?.civilite?.toUpperCase() === 'MME' || access?.civilite?.toUpperCase() === 'MADAME' || access?.civilite?.toUpperCase() === 'MLLE'     || access?.civilite?.toUpperCase() === 'MADEMOISELLE'" [ngStyle]="{'color': '#ea527e'}" size="large" ></p-avatar>

                    <span class="profile-name ml-2" id="header">{{this.fullName}}</span>
                </a>
                <ul
                    class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 left-0 top-auto">
                    <li>
                        <a (click)="goToProfile()" pRipple
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-user mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold" id="profil">{{'topBar.profil'  | translate}}</span>
                            </span>
                        </a>

                        <a pRipple (click)="logout()"
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold" id="deconnexion">{{'topBar.logout' | translate}}</span>
                            </span>
                        </a>
                    </li>
                </ul>

            <li class="right-sidebar-item">
                <a tabindex="0" (click)="onRightMenuClick()">
                    <i class="pi pi-align-right" ></i>
                    <span *ngIf="nbUnreadNouveaute > 0" class="topbar-badge">{{nbUnreadNouveaute}}</span>
                </a>
            </li>
        </ul>
    </div>
</div>

